import React from 'react';
import { useNavigate } from 'react-router-dom';

interface IProps {
  icon?: any;
  title?: String;
  className?: String;
  path?: string;
}

const ButtonWithIcon: React.FC<IProps> = ({ icon, path, title, className }) => {
  const navigate = useNavigate();
  return (
    <>
      <div
        onClick={(e) => {
          path ? navigate(`/${path}`) : e.preventDefault();
        }}
        className={`flex items-center space-x-2 font-bold ${className}`}
      >
        <p> {icon}</p>
        <p className="text-center text-white text-sm font-semibold font-[Outfit] leading-[21px]">
          {title}
        </p>
      </div>
    </>
  );
};

export default ButtonWithIcon;
